import React from 'react';
import Icon from '../../../components/AppIcon';

const DocumentContent = ({ content, isLoading }) => {
  if (isLoading) {
    return (
      <div className="bg-card rounded-lg border border-border p-6 card-shadow">
        <div className="flex items-center justify-center h-64">
          <div className="flex flex-col items-center gap-3">
            <div className="animate-spin">
              <Icon name="Loader2" size={32} className="text-primary" />
            </div>
            <p className="text-muted-foreground">
              در حال بارگذاری محتوای سند...
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (!content) {
    return (
      <div className="bg-card rounded-lg border border-border p-6 card-shadow">
        <div className="flex items-center justify-center h-64">
          <div className="flex flex-col items-center gap-3 text-center">
            <Icon name="FileX" size={48} className="text-muted-foreground" />
            <div>
              <h3 className="font-semibold text-foreground mb-1">
                محتوای سند در دسترس نیست
              </h3>
              <p className="text-muted-foreground text-sm">
                محتوای این درخواست هنوز تولید نشده است یا در حال پردازش می‌باشد.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border card-shadow">
      <div className="border-b border-border p-4">
        <div className="flex items-center gap-2">
          <Icon name="FileText" size={20} className="text-primary" />
          <h2 className="text-lg font-semibold text-foreground">
            محتوای سند تولید شده
          </h2>
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          این محتوا توسط هوش مصنوعی تولید شده و قابل ویرایش و بازنگری است
        </p>
      </div>

      <div className="p-6">
        <div className="prose prose-lg max-w-none">
          <div
            className="text-foreground leading-relaxed whitespace-pre-wrap font-vazirmatn"
            style={{
              fontFamily: 'Vazirmatn, sans-serif',
              lineHeight: '1.8',
              fontSize: '16px',
            }}>
            {content}
          </div>
        </div>
      </div>

      <div className="border-t border-border p-4 bg-muted/30">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={18} className="text-primary mt-0.5" />
          <div className="text-sm">
            <p className="font-medium text-foreground mb-1">نکته مهم:</p>
            <p className="text-muted-foreground leading-relaxed">
              این سند توسط هوش مصنوعی تولید شده و باید توسط وکیل یا مشاور حقوقی
              مورد بررسی قرار گیرد. در صورت نیاز به تغییرات، می‌توانید درخواست
              بازنگری ارسال کنید.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentContent;
